import { Link } from "react-router-dom";

function formatDate(iso) {
  try {
    return new Date(iso).toLocaleDateString("en-US", { year: "numeric", month: "long", day: "numeric" });
  } catch {
    return "";
  }
}

export default function PostRelated({ related }) {
  if (!related || related.length === 0) return null;

  return (
    <div className="mt-24 md:mt-32 max-w-[1400px] mx-auto px-6 md:px-12" data-testid="post-related">
      <div className="border-t border-white/10 pt-16">
        <p className="overline mb-4">Related Reading</p>
        <h2 className="font-serif-display text-3xl md:text-5xl text-white leading-[1.05] mb-12">
          More from the journal.
        </h2>
        <div className="grid md:grid-cols-3 gap-8">
          {related.map((r, i) => (
            <Link
              key={r.id}
              to={`/journal/${r.slug}`}
              data-testid={`related-article-${i}`}
              className="group block"
            >
              <div className="aspect-[16/10] overflow-hidden bg-[#1A1A1A] border border-white/5">
                <img
                  src={r.hero_image}
                  alt={`${r.title} — Shaji Nada`}
                  loading="lazy"
                  decoding="async"
                  className="w-full h-full object-cover transition-transform duration-[1.4s] ease-out group-hover:scale-105"
                />
              </div>
              <p className="overline mt-5">
                {r.category === "news" ? "News" : "Essay"} · {formatDate(r.published_at)}
              </p>
              <h3 className="font-serif-display text-xl md:text-2xl text-white mt-2 group-hover:text-[var(--accent)] transition-colors">
                {r.title}
              </h3>
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
}
